document.addEventListener("DOMContentLoaded", function() {
    const collectionList = document.querySelector(".collection-list");

    if (window.innerWidth >= 1024 && collectionList) {
        const leftArrow = document.createElement("button");
        leftArrow.classList.add("scroll-arrow", "left");
        leftArrow.innerHTML = "←";

        const rightArrow = document.createElement("button");
        rightArrow.classList.add("scroll-arrow", "right");
        rightArrow.innerHTML = "→";

        collectionList.parentElement.appendChild(leftArrow);
        collectionList.parentElement.appendChild(rightArrow);

        leftArrow.addEventListener("click", function() {
            collectionList.scrollBy({
                left: -300,
                behavior: "smooth"  // Smooth scrolling
            });
        });

        rightArrow.addEventListener("click", function() {
            collectionList.scrollBy({
                left: 300,
                behavior: "smooth"  // Smooth scrolling
            });
        });
    }
});

